import React from 'react';
import { Modal, Box, Typography, Grid, IconButton, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import BusinessIcon from '@mui/icons-material/Business';
import ApartmentIcon from '@mui/icons-material/Apartment';
import MapIcon from '@mui/icons-material/Map';
import InfoIcon from '@mui/icons-material/Info';
import PublicIcon from '@mui/icons-material/Public';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WifiIcon from '@mui/icons-material/Wifi';
import EngineeringIcon from '@mui/icons-material/Engineering';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

const fieldMap = [
  { key: 'site_code', label: 'Site Code', icon: <LocationOnIcon color="action" /> },
  { key: 'project_name', label: 'Project Name', icon: <BusinessIcon color="action" /> },
  { key: 'status', label: 'Status', icon: <CheckCircleIcon color="action" /> },
  {
    key: 'onfp_planning_remarks',
    label: 'ONFP Planning Remarks',
    icon: <InfoIcon color="action" />,
  },
  { key: 'bp_remarks', label: 'BP Remarks', icon: <InfoIcon color="action" /> },
  { key: 'comments', label: 'Comments', icon: <InfoIcon color="action" /> },
  { key: 'phase_name', label: 'Phase Name', icon: <EngineeringIcon color="action" /> },
  { key: 'bp', label: 'BP', icon: <BusinessIcon color="action" /> },
  { key: 'fiber_site_name', label: 'Fiber Site Name', icon: <BusinessIcon color="action" /> },
  { key: 'lat', label: 'Latitude', icon: <PublicIcon color="action" /> },
  { key: 'long', label: 'Longitude', icon: <PublicIcon color="action" /> },
  { key: 'technical_city', label: 'Technical City', icon: <MapIcon color="action" /> },
  { key: 'region', label: 'Region', icon: <MapIcon color="action" /> },
  { key: 'fiber_pop_id', label: 'Fiber POP ID', icon: <WifiIcon color="action" /> },
  { key: 'ring_name', label: 'Ring Name', icon: <WifiIcon color="action" /> },
  { key: 'ring_unique_name', label: 'Ring Unique Name', icon: <WifiIcon color="action" /> },
  { key: 'ring_name_nms', label: 'Ring Name NMS', icon: <WifiIcon color="action" /> },
  { key: 'cutover_date', label: 'Cutover Date', icon: <InfoIcon color="action" /> },
  { key: 'total_length', label: 'Total Length', icon: <EngineeringIcon color="action" /> },
  { key: 'on_net', label: 'On Net', icon: <WifiIcon color="action" /> },
  { key: 'off_net', label: 'Off Net', icon: <WifiIcon color="action" /> },
  { key: 'prefix', label: 'Prefix', icon: <BusinessIcon color="action" /> },
  { key: 'old_site_code', label: 'Old Site Code', icon: <LocationOnIcon color="action" /> },
  {
    key: 'replacement_site_code',
    label: 'Replacement Site Code',
    icon: <LocationOnIcon color="action" />,
  },
  {
    key: 'replacement_site_name',
    label: 'Replacement Site Name',
    icon: <BusinessIcon color="action" />,
  },
  {
    key: 'replacement_site_lat',
    label: 'Replacement Site Latitude',
    icon: <PublicIcon color="action" />,
  },
  {
    key: 'replacement_site_long',
    label: 'Replacement Site Longitude',
    icon: <PublicIcon color="action" />,
  },
  {
    key: 'replacement_site_proposed_ring',
    label: 'Replacement Site Proposed Ring',
    icon: <WifiIcon color="action" />,
  },
  { key: 'addendum_status', label: 'Addendum Status', icon: <InfoIcon color="action" /> },
  { key: 'descope_status', label: 'Descope Status', icon: <InfoIcon color="action" /> },
];

export default function FiberSiteDetailsModal({ open, onClose, site }) {
  if (!site) {
    return null;
  }

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          p: 4,
          background: '#fff',
          borderRadius: 2,
          maxWidth: 1000,
          width: '95vw',
          mx: 'auto',
          my: 8,
          boxShadow: 24,
          position: 'relative',
          maxHeight: { xs: '90vh', sm: '80vh' },
          overflowY: 'auto',
        }}
      >
        <IconButton onClick={onClose} sx={{ position: 'absolute', top: 8, right: 8 }}>
          <CloseIcon />
        </IconButton>
        <Typography variant="h5" gutterBottom align="center">
          Fiber Site Details
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2}>
          {fieldMap.map(
            ({ key, label, icon }) =>
              site[key] !== undefined && (
                <Grid item xs={12} sm={6} md={4} key={key}>
                  <Box
                    display="flex"
                    alignItems="center"
                    bgcolor="#fafafa"
                    borderRadius={1}
                    p={1.5}
                    mb={1}
                    border="1px solid #e0e0e0"
                  >
                    {icon}
                    <Typography variant="subtitle2" sx={{ ml: 1, minWidth: 120 }}>
                      {label}:
                    </Typography>
                    <Typography variant="body2" sx={{ ml: 1, fontWeight: 500 }}>
                      {site[key] === null || site[key] === undefined ? '-' : String(site[key])}
                    </Typography>
                  </Box>
                </Grid>
              )
          )}
        </Grid>
      </Box>
    </Modal>
  );
}
